
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import api from "./api";

function Unsubscribe() {
  const { token } = useParams();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [done, setDone] = useState(false);

  const handleUnsubscribe = async () => {
    setLoading(true);

    try {
      const response = await api.post(
        `/subscribe/unsubscribe/${token}`
      );

      setMessage(response.data.message);
      setDone(true);
    } catch (error) {
      console.error("Unsubscribe API error:", error);
      console.error("API URL:", error.config?.baseURL);
      console.error("Request path:", error.config?.url);
      console.error("Response:", error.response?.data);

      setMessage(
        error.response?.data?.message ||
          "Unable to unsubscribe. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "80px auto",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <h2>Unsubscribe from Workwear Updates</h2>

      {!done && (
        <>
          <p>
            Are you sure you no longer want to receive our email updates?
          </p>

          <button
            onClick={handleUnsubscribe}
            disabled={loading}
            style={{
              padding: "12px 24px",
              background: "#dc3545",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Unsubscribing..." : "Yes, Unsubscribe"}
          </button>
        </>
      )}

      {message && <p>{message}</p>}
    </div>
  );
}

export default Unsubscribe;
